// 📖 House chapter openers (Nina 09-29): in the house the chapter boundary
// reads ONLY the AI line, "End of Chapter 473: <title>" (the closer, titled
// from its round_analysis). The canned opener under it ("Chapter 474: Oh
// we're STILL going?? No brakes.") leaves the feed, old rows included.
// House only for now; Prompt Pals is next. Residents already skip both
// dividers (backend houseChapterLines.js). An opener whose own round carries
// an AI title (rows from before the 08-13 cadence) renders that title, so it
// stays.
const OPENER = /^Chapter \d+: /;

/** Round ids whose round_analysis carries an AI chapter title. */
export function chapterTitledRounds(actions) {
  const rounds = new Set();
  for (const a of actions || []) {
    if (a && a.type === 'round_analysis' && a.data && a.data.chapter_title) rounds.add(a.game_instance_round_id);
  }
  return rounds;
}

/** True = a canned "Chapter N: …" opener with no AI title to show. */
export function isCannedChapterOpener(action, titledRounds) {
  if (!action || action.type !== 'game_announcement' || !action.data) return false;
  const msg = action.data.message;
  if (typeof msg !== 'string' || !OPENER.test(msg.trim())) return false;
  return !(titledRounds && titledRounds.has(action.game_instance_round_id));
}
